module.exports = __webpack_public_path__ + "img/2.7bc2a49d.png";